import { getFulfillmentMethod } from './pod-fulfillment-utils';
import { getPickupFulfillmentMethod } from './store-helper';
import { getDeliveryFulfillmentMethod } from './shipping-helper';

/**
 * Single source of truth for "which fulfillment method is selected for this product", used by both
 * the pods (radio checked state) and the ATC payload so the two can never disagree. Priority:
 *   1. an explicit per-item selection (a radio click),
 *   2. a bulk pickup/delivery preference — resolved via the pods' OWN template tagging
 *      (getPickup/getDeliveryFulfillmentMethod), falling back to the auto-pick when the preferred
 *      category isn't available for the item,
 *   3. the auto-pick.
 *
 * Because the bulk resolution delegates to getStoreTemplate/getShippingTemplate, it stays in lock
 * step with what the radios show even if the store/shipping outcome logic changes.
 *
 * @param {object} product
 * @param {{
 *   selectedMethod?: string|null,
 *   bulkPreference?: 'pickup'|'delivery'|null,
 *   storeId?: string,
 *   isHideLimitedStockClearanceEnabled?: boolean,
 *   hasSameDayFilter?: boolean
 * }} [opts]
 */
export const resolveSelectedFulfillmentMethod = (product, {
  selectedMethod = null,
  bulkPreference = null,
  storeId,
  isHideLimitedStockClearanceEnabled,
  hasSameDayFilter
} = {}) => {
  if (selectedMethod) {
    return selectedMethod;
  }
  if (bulkPreference === 'pickup') {
    return getPickupFulfillmentMethod(product, { storeId, isHideLimitedStockClearanceEnabled })
      || getFulfillmentMethod(product);
  }
  if (bulkPreference === 'delivery') {
    return getDeliveryFulfillmentMethod(product, { hasSameDayFilter }) || getFulfillmentMethod(product);
  }
  return getFulfillmentMethod(product);
};
